/**
 * Словарь локализации для фронтенда
 * Поддерживаемые языки: ru (русский), en (английский)
 */

const locales = {
  ru: {
    // Общие
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успешно!",
    cancel: "Отмена",
    delete: "Удалить",
    back: "Назад",
    save: "Сохранить",
    confirm: "Подтвердить",
    
    // HomePage
    home_loading: "Загрузка данных пользователя...",
    home_referral_btn: "Реферальная система",
    home_instruction_btn: "Инструкция по подключению VPN",
    home_add_key: "+ Добавить ключ",
    home_admin_panel: "Админ панель",
    
    // UserInfoCard - нет текстов, только имя и username
    
    // ConfigurationsSection
    configs_loading: "Загружаем ваши подписки...",
    configs_empty: "У вас пока нет активных подписок",
    configs_delete_title: "Подтверждение удаления",
    configs_delete_confirm: "Вы уверены, что хотите удалить эту подписку?",
    
    // SubscriptionCard
    sub_unknown_server: "Неизвестный сервер",
    sub_until: "до",
    
    // PurchaseKeyPage — payments disabled banner
    purchase_disabled_title: "Оплата временно недоступна",
    purchase_disabled_text: "Мы проводим технические работы. Покупка VPN-подписок временно приостановлена. Попробуйте позже или обратитесь в поддержку.",
    purchase_disabled_btn: "Вернуться назад",

    // PurchaseKeyPage
    purchase_title: "Покупка VPN-ключа",
    purchase_subtitle: "Настройте параметры VPN ключа под ваши потребности",
    purchase_select_country: "Выберите страну",
    purchase_loading_servers: "Загрузка серверов...",
    purchase_checking_ping: "Проверка ping серверов...",
    purchase_no_servers: "Серверы не найдены",
    purchase_period_title: "Период действия",
    purchase_period_week: "Неделя",
    purchase_period_month: "Месяц",
    purchase_period_year: "Год",
    purchase_bonuses_title: "Использовать бонусы",
    purchase_bonuses_available: "доступно",
    purchase_bonuses_deduct: "Сумма к списанию:",
    purchase_bonuses_max: "макс.",
    purchase_bonuses_saving: "Вы экономите",
    purchase_bonuses_with: "с помощью бонусов",
    purchase_payment_title: "Способ оплаты",
    purchase_yookassa: "ЮКасса",
    purchase_yookassa_desc: "Карты РФ, СБП, ЮMoney",
    purchase_stripe: "Stripe",
    purchase_stripe_desc: "Зарубежные карты, Apple/Google Pay",
    purchase_stripe_unavailable: "Недоступно для недельной подписки",
    purchase_summary_title: "Сводка вашего тарифа",
    purchase_server: "Сервер",
    purchase_traffic: "Трафик",
    purchase_period: "Период",
    purchase_base_price: "Базовая цена:",
    purchase_bonuses: "Бонусы:",
    purchase_total: "К оплате:",
    purchase_fully_paid: "Полностью оплачено бонусами!",
    purchase_btn_pay: "Перейти к оплате",
    purchase_btn_paying: "Переход к оплате...",
    purchase_error_country: "Выберите страну",
    purchase_error_period: "Выберите период",
    
    // SubscriptionDetailsPage
    details_loading: "Загрузка подписки...",
    details_wait: "Пожалуйста, подождите",
    details_not_found: "Подписка не найдена",
    details_title: "Детали подписки",
    details_status_active: "Активна",
    details_status_expiring: "Скоро истекает",
    details_status_expired: "Истекла",
    details_status_inactive: "Неактивна",
    details_status_unknown: "Неизвестно",
    details_config_key: "Ключ конфигурации",
    details_click_to_copy: "Нажмите для копирования",
    details_copied: "Скопировано в буфер обмена!",
    details_import: "Импорт конфигурации",
    details_validity: "Срок действия",
    details_valid_until: "До",
    details_days_left: "Осталось {days} дней",
    details_expired: "Подписка истекла",
    details_traffic: "Использование трафика",
    details_traffic_used: "Использовано",
    details_delete_btn: "Удалить подписку",
    details_extend_btn: "Продлить подписку",
    
    // ReferralPage
    referral_title: "Реферальная программа",
    referral_subtitle: "Приглашайте друзей и получайте бонусы за каждую регистрацию!",
    referral_balance: "Ваш баланс",
    referral_link_title: "Ваша реферальная ссылка",
    referral_click_to_copy: "Нажмите для копирования",
    referral_copied: "Скопировано в буфер обмена!",
    referral_share: "Поделиться",
    referral_qr_show: "QR код",
    referral_qr_hide: "Скрыть QR",
    referral_qr_scan: "Отсканируйте QR код для быстрого перехода",
    referral_bonuses_title: "Бонусы за приглашения",
    referral_you_get: "Вы получите",
    referral_friend_gets: "Друг получит",
    referral_how_title: "Как получить бонусы?",
    referral_step1_title: "Поделитесь ссылкой",
    referral_step1_desc: "Отправьте реферальную ссылку друзьям",
    referral_step2_title: "Друг регистрируется",
    referral_step2_desc: "Ваш друг переходит по ссылке и регистрируется",
    referral_step3_title: "Получите бонусы",
    referral_step3_desc: "Вы автоматически получаете 50₽, ваш друг - 100₽. Средства можно будет использовать для оплаты VPN-подписок.",
    referral_share_text: "Присоединяйся к VPN боту и получи 100₽ на счет!",
    
    // VPNInstructionPage
    instruction_vpn_title: "Инструкция как добавить ключ и пользоваться VPNch1k",
    instruction_step1_title: "Скачиваем приложение",
    instruction_step1_desc: "Скачиваем приложение V2RayTun в AppStore / Google play",
    instruction_step2_title: "Копируем ключ",
    instruction_step2_desc: "Копируем ключ, который отправил вам бот и заходим в V2RayTun",
    instruction_step3_title: "Добавляем ключ",
    instruction_step3_desc: "Нажимаем «+» → «добавить из буфера» → вставляем ключ, который дал нам бот",
    instruction_step4_title: "Разрешаем конфигурации",
    instruction_step4_desc: "Разрешаем добавление конфигураций",
    instruction_step5_title: "Вводим пароль",
    instruction_step5_desc: "После это нас перебрасывает в настройки → мы вводим наш пароль",
    instruction_step6_title: "Готово!",
    instruction_step6_desc: "Теперь с радостью можно пользоваться быстрым VPN",
    instruction_home_title: "Инструкция как добавить VPN на экран «домой»",
    instruction_home_step1_title: "Открываем мини-приложение",
    instruction_home_step1_desc: "Открываем мини - приложение, которое хотим добавить на главный экран",
    instruction_home_step2_title: "Нажимаем меню",
    instruction_home_step2_desc: "Нажимаем на 3 точки в правом верхнем углу",
    instruction_home_step3_title: "Добавляем на экран",
    instruction_home_step3_desc: "Выбираем вариант «Добавить на экран «Домой»»",
    instruction_support: "Если у вас возникли проблемы с подключением, обратитесь в поддержку через бота.",
    
    // Popup messages
    popup_success_title: "Успешно!",
    popup_error_title: "Ошибка",
    popup_new_key: "Вы успешно приобрели новый VPN-ключ!",
    popup_subscription_deleted: "Подписка успешно удалена",
    popup_bonus_activated: "Подписка активирована за бонусы!",
    popup_payment_error: "Ошибка при создании платежа:",
    popup_purchase_error: "Ошибка при покупке VPN-ключа:",
    
    // ExtendSubscriptionModal
    extend_title: "Продление подписки",
    extend_server: "Сервер:",
    extend_current_expiry: "Текущая дата истечения:",
    extend_new_expiry: "Новая дата истечения:",
    extend_period: "Период продления",
    extend_use_bonuses: "Использовать бонусы",
    extend_available: "доступно",
    extend_price: "Стоимость:",
    extend_bonuses_used: "Бонусы:",
    extend_total: "Итого к оплате:",
    extend_btn: "Продлить",
    extend_btn_processing: "Обработка...",
    
    // Языки
    language: "Язык",
    language_ru: "Русский",
    language_en: "English",
    language_fa: "فارسی",

    // Единицы трафика и дата
    unit_mb: "МБ",
    unit_kb: "КБ",
    date_locale: "ru-RU",

    // OperationsPage
    ops_back: "Назад",
    ops_title: "Операции",
    ops_page_title: "Страница операций",
    ops_page_subtitle: "Здесь будет отображаться история транзакций и платежей",
    ops_back_home: "Вернуться на главную",

    // TelegramLoader
    loader_init: "Инициализация",
    loader_connecting: "Подключение к Telegram",
    loader_setup: "Настройка интерфейса",
    loader_verify: "Проверка данных",
    loader_almost: "Почти готово",
    loader_error_title: "Ошибка инициализации",
    loader_error_subtitle: "Не удалось подключиться к Telegram WebApp",
    loader_dev_mode: "Приложение работает в режиме разработки",
    loader_dev_mode_desc: "Для полной функциональности откройте приложение в Telegram",
    loader_open_title: "Откройте в Telegram",
    loader_open_subtitle: "Это приложение предназначено для работы в Telegram",
    loader_dev_title: "Для разработки",
    loader_dev_desc: "Приложение будет работать с ограниченной функциональностью",

    // LoadingOverlay
    overlay_loading: "Загрузка",
    overlay_wait: "Пожалуйста, подождите",
    overlay_user_1: "Проверка пользователя",
    overlay_user_2: "Валидация данных",
    overlay_user_3: "Настройка профиля",
    overlay_subs_1: "Загрузка подписок",
    overlay_subs_2: "Получение данных",
    overlay_subs_3: "Обновление списка",
    overlay_ops_1: "Загрузка операций",
    overlay_ops_2: "Получение истории",
    overlay_ops_3: "Обработка данных",
    overlay_purchase_1: "Обработка покупки",
    overlay_purchase_2: "Создание ключа",
    overlay_purchase_3: "Завершение операции",

    // ReferralPage — расширенные ключи
    referral_partner_balance: "Партнёрский баланс",
    referral_withdraw_btn: "Вывести",
    referral_min_amount: "Минимальная сумма вывода: {amount} ₽",
    referral_program_title: "Условия партнёрской программы",
    referral_tier1_label: "Партнёрка 1",
    referral_tier1_desc: "За каждую покупку/продление вашего клиента",
    referral_tier2_label: "Партнёрка 2",
    referral_tier2_desc: "За покупки клиентов вашего партнёра",
    referral_link_copy_hint: "Нажмите чтобы скопировать",
    referral_scan_hint: "Отсканируйте для перехода",
    referral_stats_title: "Статистика",
    referral_period_today: "Сегодня",
    referral_period_week: "Неделя",
    referral_period_month: "Месяц",
    referral_period_custom: "Свой период",
    referral_apply: "Применить",
    referral_income_title: "Доход за период",
    referral_attracted_title: "Привлечено",
    referral_people_suffix: "чел.",
    referral_no_stats: "Нет данных за выбранный период",
    referral_chart_income_key: "Доход (₽)",
    referral_chart_users_key: "Пользователи",
    referral_history_title: "История выводов",
    referral_no_withdrawals: "Заявок на вывод ещё нет",
    referral_method_sbp: "СБП",
    referral_method_card_short: "Карта",
    referral_status_pending: "На рассмотрении",
    referral_status_approved: "Одобрена",
    referral_status_rejected: "Отклонена",
    referral_modal_title: "Заявка на вывод средств",
    referral_available_balance: "Доступно к выводу: {amount} ₽",
    referral_method_label: "Способ вывода",
    referral_method_card_full: "Банковская карта",
    referral_amount_label: "Сумма вывода (₽)",
    referral_phone_label: "Номер телефона",
    referral_bank_label: "Банк",
    referral_card_label: "Номер карты",
    referral_submit: "Отправить заявку",
    referral_submit_success: "Заявка на вывод отправлена!",
    referral_submit_error: "Недостаточно средств или другая ошибка",
    referral_share_brand: "Присоединяйся к VPNCH1K!",
    referral_val_amount_req: "Укажите сумму",
    referral_val_amount_min: "Минимум {amount} ₽",
    referral_val_amount_max: "Превышает доступный баланс",
    referral_val_phone_req: "Укажите номер телефона",
    referral_val_phone_invalid: "Введите корректный номер",
    referral_val_bank_req: "Выберите банк",
    referral_bank_placeholder: "Выберите банк",
    referral_val_card_req: "Укажите номер карты",
    referral_val_card_invalid: "Введите 16 цифр без пробелов",
  },
  
  en: {
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success!",
    cancel: "Cancel",
    delete: "Delete",
    back: "Back",
    save: "Save",
    confirm: "Confirm",
    
    // HomePage
    home_loading: "Loading user data...",
    home_referral_btn: "Referral Program",
    home_instruction_btn: "VPN Connection Guide",
    home_add_key: "+ Add Key",
    home_admin_panel: "Admin Panel",
    
    // ConfigurationsSection
    configs_loading: "Loading your subscriptions...",
    configs_empty: "You don't have any active subscriptions yet",
    configs_delete_title: "Confirm Deletion",
    configs_delete_confirm: "Are you sure you want to delete this subscription?",
    
    // SubscriptionCard
    sub_unknown_server: "Unknown server",
    sub_until: "until",
    
    // PurchaseKeyPage — payments disabled banner
    purchase_disabled_title: "Payments Temporarily Unavailable",
    purchase_disabled_text: "We are performing maintenance. VPN subscription purchases are temporarily suspended. Please try again later or contact support.",
    purchase_disabled_btn: "Go Back",

    // PurchaseKeyPage
    purchase_title: "Purchase VPN Key",
    purchase_subtitle: "Configure your VPN key parameters to fit your needs",
    purchase_select_country: "Select Country",
    purchase_loading_servers: "Loading servers...",
    purchase_checking_ping: "Checking server ping...",
    purchase_no_servers: "No servers found",
    purchase_period_title: "Subscription Period",
    purchase_period_week: "Week",
    purchase_period_month: "Month",
    purchase_period_year: "Year",
    purchase_bonuses_title: "Use Bonuses",
    purchase_bonuses_available: "available",
    purchase_bonuses_deduct: "Amount to deduct:",
    purchase_bonuses_max: "max.",
    purchase_bonuses_saving: "You save",
    purchase_bonuses_with: "with bonuses",
    purchase_payment_title: "Payment Method",
    purchase_yookassa: "YooKassa",
    purchase_yookassa_desc: "Russian cards, SBP, YooMoney",
    purchase_stripe: "Stripe",
    purchase_stripe_desc: "International cards, Apple/Google Pay",
    purchase_stripe_unavailable: "Not available for weekly subscription",
    purchase_summary_title: "Your Plan Summary",
    purchase_server: "Server",
    purchase_traffic: "Traffic",
    purchase_period: "Period",
    purchase_base_price: "Base price:",
    purchase_bonuses: "Bonuses:",
    purchase_total: "Total:",
    purchase_fully_paid: "Fully paid with bonuses!",
    purchase_btn_pay: "Proceed to Payment",
    purchase_btn_paying: "Redirecting to payment...",
    purchase_error_country: "Please select a country",
    purchase_error_period: "Please select a period",
    
    // SubscriptionDetailsPage
    details_loading: "Loading subscription...",
    details_wait: "Please wait",
    details_not_found: "Subscription not found",
    details_title: "Subscription Details",
    details_status_active: "Active",
    details_status_expiring: "Expiring Soon",
    details_status_expired: "Expired",
    details_status_inactive: "Inactive",
    details_status_unknown: "Unknown",
    details_config_key: "Configuration Key",
    details_click_to_copy: "Click to copy",
    details_copied: "Copied to clipboard!",
    details_import: "Import Configuration",
    details_validity: "Validity Period",
    details_valid_until: "Until",
    details_days_left: "{days} days remaining",
    details_expired: "Subscription expired",
    details_traffic: "Traffic Usage",
    details_traffic_used: "Used",
    details_delete_btn: "Delete Subscription",
    details_extend_btn: "Extend Subscription",
    
    // ReferralPage
    referral_title: "Referral Program",
    referral_subtitle: "Invite friends and earn bonuses for each registration!",
    referral_balance: "Your Balance",
    referral_link_title: "Your Referral Link",
    referral_click_to_copy: "Click to copy",
    referral_copied: "Copied to clipboard!",
    referral_share: "Share",
    referral_qr_show: "QR Code",
    referral_qr_hide: "Hide QR",
    referral_qr_scan: "Scan QR code for quick access",
    referral_bonuses_title: "Referral Bonuses",
    referral_you_get: "You get",
    referral_friend_gets: "Friend gets",
    referral_how_title: "How to get bonuses?",
    referral_step1_title: "Share the link",
    referral_step1_desc: "Send your referral link to friends",
    referral_step2_title: "Friend registers",
    referral_step2_desc: "Your friend follows the link and registers",
    referral_step3_title: "Get bonuses",
    referral_step3_desc: "You automatically get 50₽, your friend gets 100₽. The funds can be used to pay for VPN subscriptions.",
    referral_share_text: "Join VPN bot and get 100₽ bonus!",
    
    // VPNInstructionPage
    instruction_vpn_title: "How to add a key and use VPNch1k",
    instruction_step1_title: "Download the app",
    instruction_step1_desc: "Download V2RayTun from AppStore / Google Play",
    instruction_step2_title: "Copy the key",
    instruction_step2_desc: "Copy the key sent by the bot and open V2RayTun",
    instruction_step3_title: "Add the key",
    instruction_step3_desc: "Tap «+» → «add from clipboard» → paste the key from the bot",
    instruction_step4_title: "Allow configurations",
    instruction_step4_desc: "Allow adding configurations",
    instruction_step5_title: "Enter password",
    instruction_step5_desc: "You'll be redirected to settings → enter your password",
    instruction_step6_title: "Done!",
    instruction_step6_desc: "Now you can enjoy fast VPN",
    instruction_home_title: "How to add VPN to home screen",
    instruction_home_step1_title: "Open mini-app",
    instruction_home_step1_desc: "Open the mini-app you want to add to home screen",
    instruction_home_step2_title: "Tap menu",
    instruction_home_step2_desc: "Tap the 3 dots in the upper right corner",
    instruction_home_step3_title: "Add to screen",
    instruction_home_step3_desc: "Select «Add to Home Screen»",
    instruction_support: "If you have connection issues, contact support via the bot.",
    
    // Popup messages
    popup_success_title: "Success!",
    popup_error_title: "Error",
    popup_new_key: "You have successfully purchased a new VPN key!",
    popup_subscription_deleted: "Subscription successfully deleted",
    popup_bonus_activated: "Subscription activated with bonuses!",
    popup_payment_error: "Error creating payment:",
    popup_purchase_error: "Error purchasing VPN key:",
    
    // ExtendSubscriptionModal
    extend_title: "Extend Subscription",
    extend_server: "Server:",
    extend_current_expiry: "Current expiry date:",
    extend_new_expiry: "New expiry date:",
    extend_period: "Extension Period",
    extend_use_bonuses: "Use Bonuses",
    extend_available: "available",
    extend_price: "Price:",
    extend_bonuses_used: "Bonuses:",
    extend_total: "Total to pay:",
    extend_btn: "Extend",
    extend_btn_processing: "Processing...",
    
    // Languages
    language: "Language",
    language_ru: "Русский",
    language_en: "English",
    language_fa: "فارسی",

    // Traffic units & date
    unit_mb: "MB",
    unit_kb: "KB",
    date_locale: "en-US",

    // OperationsPage
    ops_back: "Back",
    ops_title: "Operations",
    ops_page_title: "Operations Page",
    ops_page_subtitle: "Transaction and payment history will be displayed here",
    ops_back_home: "Back to Home",

    // TelegramLoader
    loader_init: "Initializing",
    loader_connecting: "Connecting to Telegram",
    loader_setup: "Setting up interface",
    loader_verify: "Verifying data",
    loader_almost: "Almost ready",
    loader_error_title: "Initialization Error",
    loader_error_subtitle: "Failed to connect to Telegram WebApp",
    loader_dev_mode: "App is running in development mode",
    loader_dev_mode_desc: "Open the app in Telegram for full functionality",
    loader_open_title: "Open in Telegram",
    loader_open_subtitle: "This app is designed to work inside Telegram",
    loader_dev_title: "For development",
    loader_dev_desc: "The app will work with limited functionality",

    // LoadingOverlay
    overlay_loading: "Loading",
    overlay_wait: "Please wait",
    overlay_user_1: "Checking user",
    overlay_user_2: "Validating data",
    overlay_user_3: "Setting up profile",
    overlay_subs_1: "Loading subscriptions",
    overlay_subs_2: "Fetching data",
    overlay_subs_3: "Updating list",
    overlay_ops_1: "Loading operations",
    overlay_ops_2: "Fetching history",
    overlay_ops_3: "Processing data",
    overlay_purchase_1: "Processing purchase",
    overlay_purchase_2: "Creating key",
    overlay_purchase_3: "Finishing operation",

    // ReferralPage — extended keys
    referral_partner_balance: "Partner Balance",
    referral_withdraw_btn: "Withdraw",
    referral_min_amount: "Minimum withdrawal: {amount} ₽",
    referral_program_title: "Partner Program Terms",
    referral_tier1_label: "Tier 1",
    referral_tier1_desc: "For every purchase/renewal by your client",
    referral_tier2_label: "Tier 2",
    referral_tier2_desc: "For purchases by clients of your partner",
    referral_link_copy_hint: "Click to copy",
    referral_scan_hint: "Scan to open",
    referral_stats_title: "Statistics",
    referral_period_today: "Today",
    referral_period_week: "Week",
    referral_period_month: "Month",
    referral_period_custom: "Custom",
    referral_apply: "Apply",
    referral_income_title: "Income for period",
    referral_attracted_title: "Attracted",
    referral_people_suffix: "people",
    referral_no_stats: "No data for selected period",
    referral_chart_income_key: "Income (₽)",
    referral_chart_users_key: "Users",
    referral_history_title: "Withdrawal History",
    referral_no_withdrawals: "No withdrawal requests yet",
    referral_method_sbp: "SBP",
    referral_method_card_short: "Card",
    referral_status_pending: "Pending",
    referral_status_approved: "Approved",
    referral_status_rejected: "Rejected",
    referral_modal_title: "Withdrawal Request",
    referral_available_balance: "Available to withdraw: {amount} ₽",
    referral_method_label: "Withdrawal method",
    referral_method_card_full: "Bank card",
    referral_amount_label: "Withdrawal amount (₽)",
    referral_phone_label: "Phone number",
    referral_bank_label: "Bank",
    referral_card_label: "Card number",
    referral_submit: "Submit request",
    referral_submit_success: "Withdrawal request submitted!",
    referral_submit_error: "Insufficient funds or other error",
    referral_share_brand: "Join VPNCH1K!",
    referral_val_amount_req: "Enter amount",
    referral_val_amount_min: "Minimum {amount} ₽",
    referral_val_amount_max: "Exceeds available balance",
    referral_val_phone_req: "Enter phone number",
    referral_val_phone_invalid: "Enter a valid phone number",
    referral_val_bank_req: "Select a bank",
    referral_bank_placeholder: "Select bank",
    referral_val_card_req: "Enter card number",
    referral_val_card_invalid: "Enter 16 digits without spaces",
  },

  fa: {
    // عمومی
    loading: "در حال بارگذاری...",
    error: "خطا",
    success: "موفق!",
    cancel: "انصراف",
    delete: "حذف",
    back: "بازگشت",
    save: "ذخیره",
    confirm: "تأیید",

    // HomePage
    home_loading: "در حال بارگذاری اطلاعات کاربر...",
    home_referral_btn: "سیستم ارجاع",
    home_instruction_btn: "راهنمای اتصال VPN",
    home_add_key: "+ افزودن کلید",
    home_admin_panel: "پنل ادمین",

    // ConfigurationsSection
    configs_loading: "در حال بارگذاری اشتراک‌های شما...",
    configs_empty: "هنوز هیچ اشتراک فعالی ندارید",
    configs_delete_title: "تأیید حذف",
    configs_delete_confirm: "آیا مطمئن هستید که می‌خواهید این اشتراک را حذف کنید؟",

    // SubscriptionCard
    sub_unknown_server: "سرور ناشناس",
    sub_until: "تا",

    // PurchaseKeyPage — payments disabled banner
    purchase_disabled_title: "پرداخت موقتاً در دسترس نیست",
    purchase_disabled_text: "ما در حال انجام تعمیرات فنی هستیم. خرید اشتراک VPN موقتاً متوقف شده است. لطفاً بعداً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.",
    purchase_disabled_btn: "بازگشت",

    // PurchaseKeyPage
    purchase_title: "خرید کلید VPN",
    purchase_subtitle: "پارامترهای کلید VPN را متناسب با نیاز خود تنظیم کنید",
    purchase_select_country: "کشور را انتخاب کنید",
    purchase_loading_servers: "در حال بارگذاری سرورها...",
    purchase_checking_ping: "در حال بررسی پینگ سرورها...",
    purchase_no_servers: "سروری یافت نشد",
    purchase_period_title: "دوره اشتراک",
    purchase_period_week: "هفتگی",
    purchase_period_month: "ماهانه",
    purchase_period_year: "سالانه",
    purchase_bonuses_title: "استفاده از امتیازها",
    purchase_bonuses_available: "موجود",
    purchase_bonuses_deduct: "مبلغ کسر شده:",
    purchase_bonuses_max: "حداکثر",
    purchase_bonuses_saving: "صرفه‌جویی می‌کنید",
    purchase_bonuses_with: "با استفاده از امتیازها",
    purchase_payment_title: "روش پرداخت",
    purchase_yookassa: "YooKassa",
    purchase_yookassa_desc: "کارت‌های روسی، SBP، YooMoney",
    purchase_stripe: "Stripe",
    purchase_stripe_desc: "کارت‌های بین‌المللی، Apple/Google Pay",
    purchase_stripe_unavailable: "برای اشتراک هفتگی موجود نیست",
    purchase_summary_title: "خلاصه طرح شما",
    purchase_server: "سرور",
    purchase_traffic: "ترافیک",
    purchase_period: "دوره",
    purchase_base_price: "قیمت پایه:",
    purchase_bonuses: "امتیازها:",
    purchase_total: "قابل پرداخت:",
    purchase_fully_paid: "کاملاً با امتیاز پرداخت شد!",
    purchase_btn_pay: "رفتن به درگاه پرداخت",
    purchase_btn_paying: "در حال انتقال به درگاه...",
    purchase_error_country: "لطفاً کشور را انتخاب کنید",
    purchase_error_period: "لطفاً دوره را انتخاب کنید",

    // SubscriptionDetailsPage
    details_loading: "در حال بارگذاری اشتراک...",
    details_wait: "لطفاً صبر کنید",
    details_not_found: "اشتراک یافت نشد",
    details_title: "جزئیات اشتراک",
    details_status_active: "فعال",
    details_status_expiring: "به زودی منقضی می‌شود",
    details_status_expired: "منقضی شده",
    details_status_inactive: "غیرفعال",
    details_status_unknown: "نامشخص",
    details_config_key: "کلید پیکربندی",
    details_click_to_copy: "برای کپی کلیک کنید",
    details_copied: "در کلیپ‌بورد کپی شد!",
    details_import: "وارد کردن پیکربندی",
    details_validity: "دوره اعتبار",
    details_valid_until: "تا",
    details_days_left: "{days} روز مانده",
    details_expired: "اشتراک منقضی شده",
    details_traffic: "مصرف ترافیک",
    details_traffic_used: "مصرف شده",
    details_delete_btn: "حذف اشتراک",
    details_extend_btn: "تمدید اشتراک",

    // ReferralPage
    referral_title: "برنامه ارجاع",
    referral_subtitle: "دوستانتان را دعوت کنید و برای هر ثبت‌نام امتیاز بگیرید!",
    referral_balance: "موجودی شما",
    referral_link_title: "لینک ارجاع شما",
    referral_click_to_copy: "برای کپی کلیک کنید",
    referral_copied: "در کلیپ‌بورد کپی شد!",
    referral_share: "اشتراک‌گذاری",
    referral_qr_show: "کد QR",
    referral_qr_hide: "پنهان کردن QR",
    referral_qr_scan: "کد QR را برای دسترسی سریع اسکن کنید",
    referral_bonuses_title: "امتیازهای دعوت",
    referral_you_get: "شما دریافت می‌کنید",
    referral_friend_gets: "دوست دریافت می‌کند",
    referral_how_title: "چگونه امتیاز بگیرید؟",
    referral_step1_title: "لینک را به اشتراک بگذارید",
    referral_step1_desc: "لینک ارجاع خود را برای دوستانتان ارسال کنید",
    referral_step2_title: "دوست ثبت‌نام می‌کند",
    referral_step2_desc: "دوست شما روی لینک کلیک می‌کند و ثبت‌نام می‌کند",
    referral_step3_title: "امتیاز بگیرید",
    referral_step3_desc: "شما به‌طور خودکار ۵۰ روبل و دوستتان ۱۰۰ روبل دریافت می‌کند. این وجه می‌تواند برای پرداخت اشتراک‌های VPN استفاده شود.",
    referral_share_text: "به ربات VPN بپیوندید و ۱۰۰ روبل هدیه بگیرید!",

    // VPNInstructionPage
    instruction_vpn_title: "راهنمای افزودن کلید و استفاده از VPNch1k",
    instruction_step1_title: "دانلود برنامه",
    instruction_step1_desc: "برنامه V2RayTun را از AppStore یا Google Play دانلود کنید",
    instruction_step2_title: "کپی کلید",
    instruction_step2_desc: "کلیدی که ربات ارسال کرده را کپی کنید و وارد V2RayTun شوید",
    instruction_step3_title: "افزودن کلید",
    instruction_step3_desc: "روی «+» بزنید ← «افزودن از کلیپ‌بورد» ← کلید را جای‌گذاری کنید",
    instruction_step4_title: "اجازه دادن به پیکربندی‌ها",
    instruction_step4_desc: "اجازه افزودن پیکربندی‌ها را بدهید",
    instruction_step5_title: "ورود رمز عبور",
    instruction_step5_desc: "به تنظیمات منتقل می‌شوید ← رمز عبور خود را وارد کنید",
    instruction_step6_title: "آماده است!",
    instruction_step6_desc: "اکنون می‌توانید از VPN سریع لذت ببرید",
    instruction_home_title: "راهنمای افزودن VPN به صفحه اصلی",
    instruction_home_step1_title: "باز کردن مینی‌اپ",
    instruction_home_step1_desc: "مینی‌اپی که می‌خواهید به صفحه اصلی اضافه کنید را باز کنید",
    instruction_home_step2_title: "فشردن منو",
    instruction_home_step2_desc: "روی ۳ نقطه در گوشه بالا سمت راست بزنید",
    instruction_home_step3_title: "افزودن به صفحه",
    instruction_home_step3_desc: "گزینه «افزودن به صفحه اصلی» را انتخاب کنید",
    instruction_support: "اگر مشکلی در اتصال دارید، از طریق ربات با پشتیبانی تماس بگیرید.",

    // Popup messages
    popup_success_title: "موفق!",
    popup_error_title: "خطا",
    popup_new_key: "شما با موفقیت یک کلید VPN جدید خریداری کردید!",
    popup_subscription_deleted: "اشتراک با موفقیت حذف شد",
    popup_bonus_activated: "اشتراک با امتیاز فعال شد!",
    popup_payment_error: "خطا در ایجاد پرداخت:",
    popup_purchase_error: "خطا در خرید کلید VPN:",

    // ExtendSubscriptionModal
    extend_title: "تمدید اشتراک",
    extend_server: "سرور:",
    extend_current_expiry: "تاریخ انقضای فعلی:",
    extend_new_expiry: "تاریخ انقضای جدید:",
    extend_period: "دوره تمدید",
    extend_use_bonuses: "استفاده از امتیازها",
    extend_available: "موجود",
    extend_price: "قیمت:",
    extend_bonuses_used: "امتیازها:",
    extend_total: "جمع قابل پرداخت:",
    extend_btn: "تمدید",
    extend_btn_processing: "در حال پردازش...",

    // زبان‌ها
    language: "زبان",
    language_ru: "Русский",
    language_en: "English",
    language_fa: "فارسی",

    // واحدهای ترافیک و تاریخ
    unit_mb: "مگابایت",
    unit_kb: "کیلوبایت",
    date_locale: "fa-IR",

    // OperationsPage
    ops_back: "بازگشت",
    ops_title: "عملیات",
    ops_page_title: "صفحه عملیات",
    ops_page_subtitle: "تاریخچه تراکنش‌ها و پرداخت‌ها اینجا نمایش داده می‌شود",
    ops_back_home: "بازگشت به صفحه اصلی",

    // TelegramLoader
    loader_init: "در حال راه‌اندازی",
    loader_connecting: "اتصال به Telegram",
    loader_setup: "تنظیم رابط کاربری",
    loader_verify: "تأیید اطلاعات",
    loader_almost: "تقریباً آماده",
    loader_error_title: "خطای راه‌اندازی",
    loader_error_subtitle: "اتصال به Telegram WebApp برقرار نشد",
    loader_dev_mode: "برنامه در حالت توسعه اجرا می‌شود",
    loader_dev_mode_desc: "برای عملکرد کامل، برنامه را در Telegram باز کنید",
    loader_open_title: "در Telegram باز کنید",
    loader_open_subtitle: "این برنامه برای استفاده در داخل Telegram طراحی شده است",
    loader_dev_title: "برای توسعه",
    loader_dev_desc: "برنامه با قابلیت‌های محدود کار خواهد کرد",

    // LoadingOverlay
    overlay_loading: "بارگذاری",
    overlay_wait: "لطفاً صبر کنید",
    overlay_user_1: "بررسی کاربر",
    overlay_user_2: "اعتبارسنجی داده‌ها",
    overlay_user_3: "تنظیم پروفایل",
    overlay_subs_1: "بارگذاری اشتراک‌ها",
    overlay_subs_2: "دریافت داده‌ها",
    overlay_subs_3: "به‌روزرسانی فهرست",
    overlay_ops_1: "بارگذاری عملیات",
    overlay_ops_2: "دریافت تاریخچه",
    overlay_ops_3: "پردازش داده‌ها",
    overlay_purchase_1: "پردازش خرید",
    overlay_purchase_2: "ایجاد کلید",
    overlay_purchase_3: "اتمام عملیات",

    // ReferralPage — کلیدهای توسعه‌یافته
    referral_partner_balance: "موجودی شراکت",
    referral_withdraw_btn: "برداشت",
    referral_min_amount: "حداقل مبلغ برداشت: {amount} ₽",
    referral_program_title: "شرایط برنامه شراکت",
    referral_tier1_label: "سطح ۱",
    referral_tier1_desc: "برای هر خرید/تمدید توسط کاربر شما",
    referral_tier2_label: "سطح ۲",
    referral_tier2_desc: "برای خریدهای کاربران شریک شما",
    referral_link_copy_hint: "برای کپی کلیک کنید",
    referral_scan_hint: "برای باز کردن اسکن کنید",
    referral_stats_title: "آمار",
    referral_period_today: "امروز",
    referral_period_week: "هفته",
    referral_period_month: "ماه",
    referral_period_custom: "دوره دلخواه",
    referral_apply: "اعمال",
    referral_income_title: "درآمد دوره",
    referral_attracted_title: "جذب‌شده",
    referral_people_suffix: "نفر",
    referral_no_stats: "داده‌ای برای دوره انتخاب‌شده وجود ندارد",
    referral_chart_income_key: "درآمد (₽)",
    referral_chart_users_key: "کاربران",
    referral_history_title: "تاریخچه برداشت",
    referral_no_withdrawals: "هنوز درخواست برداشتی وجود ندارد",
    referral_method_sbp: "SBP",
    referral_method_card_short: "کارت",
    referral_status_pending: "در انتظار بررسی",
    referral_status_approved: "تأیید شده",
    referral_status_rejected: "رد شده",
    referral_modal_title: "درخواست برداشت وجه",
    referral_available_balance: "موجودی قابل برداشت: {amount} ₽",
    referral_method_label: "روش برداشت",
    referral_method_card_full: "کارت بانکی",
    referral_amount_label: "مبلغ برداشت (₽)",
    referral_phone_label: "شماره تلفن",
    referral_bank_label: "بانک",
    referral_card_label: "شماره کارت",
    referral_submit: "ارسال درخواست",
    referral_submit_success: "درخواست برداشت ارسال شد!",
    referral_submit_error: "موجودی ناکافی یا خطای دیگر",
    referral_share_brand: "به VPNCH1K بپیوندید!",
    referral_val_amount_req: "مبلغ را وارد کنید",
    referral_val_amount_min: "حداقل {amount} ₽",
    referral_val_amount_max: "از موجودی بیشتر است",
    referral_val_phone_req: "شماره تلفن را وارد کنید",
    referral_val_phone_invalid: "شماره معتبر وارد کنید",
    referral_val_bank_req: "بانک را انتخاب کنید",
    referral_bank_placeholder: "انتخاب بانک",
    referral_val_card_req: "شماره کارت را وارد کنید",
    referral_val_card_invalid: "۱۶ رقم بدون فاصله وارد کنید",
  }
};

/**
 * Получить текст на указанном языке
 * @param {string} key - Ключ текста
 * @param {string} lang - Код языка (ru или en)
 * @param {object} params - Параметры для замены в строке
 * @returns {string} Локализованная строка
 */
export const t = (key, lang = 'ru', params = {}) => {
  // Если язык не поддерживается, используем русский
  if (!locales[lang]) {
    lang = 'ru';
  }
  
  // Получаем текст
  let text = locales[lang][key] || locales['ru'][key] || key;
  
  // Заменяем параметры
  Object.keys(params).forEach(param => {
    text = text.replace(new RegExp(`{${param}}`, 'g'), params[param]);
  });
  
  return text;
};

export default locales;

